import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle} from "react";
import {
  Modal,
  Form,
  Row,
  Col,
  Select,
  Input,
  Button,
  Space,
  message,
  DatePicker
} from "antd";
import { HomeOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import dayjs from "dayjs";
import { CustomUploadNew1 } from "@/hocComponents";
import commonFn from "@/utils/commonFn";

const MainContractModal = forwardRef(({id, submitInitFn,}, ref) => {
    const [form] = Form.useForm();
    const [type, setType] = useState('add');
    const [rollId, setRollId] = useState(0);
    const [modalName, setModalName] = useState('Payment Request');
    const [modalFlag, setModalFlag] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [filePaths, setFilePaths] = useState([]);
    const [vendorList, setVendorList] = useState([]);
    const [vendorOption, setVendorOption] = useState({});
    const [detail, setDetail] = useState(null);
    const [isSwapKey, setIsSwapKey] = useState(0);
    
    const customUploadNewRef = useRef(null);
    
    useImperativeHandle(ref, () => ({
      openModal: ({type, modalName, rollId}) => {
        setType(type)
        setModalName(modalName)
        setRollId(rollId)
        setModalFlag(true)
      }
    }));

    const afterOpenChangeFn = (flag) => {
      if(flag){
        getLoanTypeListFn()
        if(type !== 'add'){
          getDetailFn()
        } else {
          getVendorList()
        }
      }else{
        setDetail(null)
        setVendorList([])
        setLoanTypeList([])
        setVendorOption({})
        form.resetFields();
        setBtnLoading(false)
        setBtnDisabled(false)
      }
    }

    const [loanTypeList, setLoanTypeList] = useState([]);

    const selcetChangeFn = async (option = {}, key) => {
      setVendorOption(option);
      form.setFieldsValue({ [key]: option[key] });
    };

    const getLoanTypeListFn = async() => {
      const response = await http.get(api.getMortgageLoanType);
      if (response.code === "1") {
        setLoanTypeList(response.data);
      }
    }

    const getVendorList = async (content = '') => {
      const response = await http.get(api.searchMortgageVendorType, {params: {content, vendorType: 'Bank'}});
      if (response?.code === "1") {
        const list = (response.data || []).map((item) => ({
          value: item.vendid,
          label: item.vendorName,
          vendorId: item.vendorId,
        }));
        setVendorList(list);
        return list
      }
      return []
    };

    const getDetailFn = async() => {
      setBtnDisabled(true)
      const response = await http.get(api.getMortgageRollDetail, { params: {rollId} });
      const { loanDate, loanEndDate, swapEndDate, repaymentMonth, paidOffDate, vendorId, vendorList, fileList } = response.data
      if (response?.code === "1") {
        const temp = {
          ...response.data,
          loanDate: loanDate && dayjs(loanDate),
          loanEndDate: loanEndDate && dayjs(loanEndDate),
          swapEndDate: swapEndDate && dayjs(swapEndDate),
          repaymentMonth: repaymentMonth && dayjs(repaymentMonth),
          paidOffDate: paidOffDate && dayjs(paidOffDate),
        }
        setDetail(temp)
        if(vendorId){
          const vendorListTemp = vendorList.map(item => ({value: item.vendid, label: item.vendorName, vendorId: item.vendorId,}))
          setVendorList(vendorListTemp);
          selcetChangeFn(vendorListTemp[0], 'vendorId')
        } else {
          getVendorList()
        }
        form.setFieldsValue(temp);
        if(['edit'].includes(type) && customUploadNewRef.current){
          const list = (fileList || [])?.map(item => ({ ...item, url: item.allPath, baseUrl: item.allPath, name: item.name || item.fileName, type: item.contentType}))
          customUploadNewRef.current.initUpdateList(list)
        }
      }
      setBtnDisabled(false)
    }

    // const testFn = async () => {
    // }

    const submitAddOrEditFn = async(type) => {
      const flag = type === 'add'
      setBtnLoading(true)
      const { loanDate, loanEndDate, swapEndDate, repaymentMonth, paidOffDate } = form.getFieldValue()
      const formValues = form.getFieldValue()
      // 需要转换为字符串的字段
      const stringFields = ['variableIndex', 'marginRate', 'ceiling', 'floor', 'prepaidPenalty']
      const convertedValues = commonFn.convertFieldsToString(formValues, stringFields)
      const response = await http.post(flag ? api.saveMortgageRolling : api.updateMortgageRolling, {
        // ...form.getFieldValue(),
         ...convertedValues,
        loanDateStr: loanDate?.format('YYYY-MM-DD') || '',
        loanEndDateStr: loanEndDate?.format('YYYY-MM-DD') || '',
        swapEndDateStr: swapEndDate?.format('YYYY-MM-DD') || '',
        paidOffDateStr: paidOffDate?.format('YYYY-MM-DD') || '',
        repaymentMonthStr: repaymentMonth?.format('YYYY-MM') || '',
        
        fileList: filePaths.filter(item => !item.id)
      });
      if (response.code === "1") {
        message.success(`${flag ? 'New' : 'Edit'} successfully`);
        setModalFlag(false)
        submitInitFn();
      } else {
        commonFn.modalFailedFn(response)
      }
      setBtnLoading(false)
    }

    const submitFn = async() => {
      form.validateFields().then(value => {
        if(type === 'add' || type === 'edit'){
          submitAddOrEditFn(type)
        }
      }).catch(err =>{
        console.log(err,'===err');
      })
    }

    const deleteOldFn = async(file) => {
      let flag = false
      const response = await http.get(api.mortgageDelRollFile, { params: {id: file.id} });
      if (response.code === "1") {
        flag = true
      }
      return flag
    }

    const addOldFn = async(file) => {
      setBtnDisabled(true)
      const list = [file[file.length - 1]]
      const formData = new FormData();
      list.forEach((item) => formData.append("files", item.originFileObj));
      const response = await http.post(api.mortgageUploadFile, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.code === "1") {
        return {
          flag: true,
          fileData: response.data[0]
        }
      } else {
        return {
          flag: false,
          fileData: {}
        }
      }
    }

  return (
    <Modal
      title={
        <div style={{ fontSize: "24px", fontWeight: "bold", color: "#3c8dbc" }}>
          <HomeOutlined style={{ marginRight: "8px" }} />
          {modalName}
          <div
            style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
          ></div>
        </div>
      }
      centered
      open={modalFlag}
      onCancel={() => setModalFlag(false)}
      footer={null}
      maskClosable={false}
      afterOpenChange={afterOpenChangeFn}
      width="80%"
    >
      <Form
        form={form}
        layout="horizontal"
        labelCol={{span: 8}}
        wrapperCol={{span: 16}}
        labelWrap={true}
        labelAlign="right"
        validateMessages={{
          required: "${label} is required!",
        }}
      >
        <Row gutter={[16, 16]}>
          <Col span={6}>
            <div
              style={{
                marginBottom: "16px",
                fontWeight: "bold",
                fontSize: "20px",
              }}
            >
              <HomeOutlined style={{ marginRight: "8px" }} />
              Mortgage Form
            </div>

            <Form.Item
                // style={{marginBottom: detail?.showVendorNameFlag ? 0 : 24}}
                name="vendorId"
                label="Lender"
                rules={[{ required: true, message: 'Lender is required!' }]}
            >
                <Select
                    allowClear
                    showSearch
                    placeholder="Select a type"
                    onChange={(value, option) => selcetChangeFn(option, 'vendorId')}
                    onSearch={(value) => {getVendorList(value)}}
                    optionLabelProp={{ label: "value" }}
                    value={vendorOption?.value}
                    filterOption={(input, option) =>
                        (option?.label ?? "")?.toLowerCase().includes(input.toLowerCase())
                    }
                    options={vendorList}
                />
                <div>{vendorOption?.label || ''}</div>
            </Form.Item>

            <Form.Item
              name="loanNumber"
              label="Loan Number"
              rules={[{ required: true, message: 'Loan Number is required!' }]}
            >
              <Input
                placeholder="Please input Loan Number"
              />
            </Form.Item>

            {commonFn.formInputNumberDoc({
              form,
              name: "originalLoan",
              label: "Original Loan Amount",
              allowNegative: true,
              isNoRequired: true
            })}

            {commonFn.formInputNumberDoc({
              form,
              name: "repaymentPrincipal",
              label: "Principal",
              allowNegative: true,
              isNoRequired: true
            })}

            {commonFn.formInputNumberDoc({
              form,
              name: "repaymentInterest",
              label: "Interest",
              allowNegative: true,
              isNoRequired: true
            })}

            {commonFn.formInputNumberDoc({
              form,
              name: "monthlyPrincipal",
              label: "Monthly Principal",
              allowNegative: true,
              isNoRequired: true
            })}

            {commonFn.formInputNumberDoc({
              form,
              name: "monthlyInterest",
              label: "Monthly Interest",
              allowNegative: true,
              isNoRequired: true
            })}

            <Form.Item
              name="repaymentMonth"
              label="Repayment Month Date"
              // rules={[{ required: true, message: 'Repayment Month Date is required!' }]}
            >
              <DatePicker
                style={{ width: "100%" }}
                picker="month"
                format="MM/YYYY"
              />
            </Form.Item>

            {commonFn.formInputNumberDoc({
              form,
              name: "currentLoan",
              label: "Current Loan",
              allowNegative: true,
              isNoRequired: true
            })}

            {/* {commonFn.formInputNumberDoc({
              form,
              name: "monthlyPayment",
              label: "Monthly Payment",
              allowNegative: true
            })} */}

            <Form.Item
              name="achAccount"
              label="ACH Account"
              // rules={[{ required: true, message: 'ACH Account is required!' }]}
            >
              <Input
                placeholder="Please input ACH Account"
              />
            </Form.Item>

            <Form.Item
              name="isSwap"
              label="Swap"
              // rules={[{ required: true, message: 'Swap is required!' }]}
            >
              <Select
                showSearch
                placeholder="Select a type"
                onChange={(e) => setIsSwapKey(+new Date())}
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={[
                    {
                      label: 'No',
                      value: 0
                    },
                    {
                      label: 'Yes',
                      value: 1
                    },
                ]}
              />
            </Form.Item>
            
            {form.getFieldValue().isSwap === 1 && (
              <Form.Item
                name="swapEndDate"
                label="Fix End Date"
                // rules={[
                //     { required: true, message: "Fix End Date is required!" },
                // ]}
              >
              <DatePicker
                style={{ width: "100%" }}
                format="MM/DD/YYYY"
              />
              </Form.Item>
            ) || null}

            <Form.Item
              name="termAmortPeriod"
              label="Term/Amort"
            >
              <Input
                placeholder="Please input Term/Amort"
              />
            </Form.Item>

            {commonFn.formInputNumberDoc({
              form,
              name: "dscr",
              label: "DSCR",
              allowNegative: true,
              isNoRequired: true
            })}

            <Form.Item
              name="loanDate"
              label="Loan Date"
            >
              <DatePicker
                style={{ width: "100%" }}
                format="MM/DD/YYYY"
              />
            </Form.Item>

            <Form.Item
              name="loanEndDate"
              label="Maturity Date"
            >
              <DatePicker
                style={{ width: "100%" }}
                format="MM/DD/YYYY"
              />
            </Form.Item>

            {/* {commonFn.interestRateDoc({
              form,
              name: "variableIndex",
              label: "Variable Index",
              allowNegative: true,
              isNoRequired: true
            })} */}
               <Form.Item
              name="variableIndex"
              label="Variable Index"
            >
              <Input
                placeholder="Please input Variable Index"
              />
            </Form.Item>

          </Col>
          <Col span={6}>
            <div
              style={{
                marginBottom: "16px",
                fontWeight: "bold",
                fontSize: "20px",
              }}
            >
              <HomeOutlined style={{ marginRight: "8px" }} />
              Mortgage Form (Contd)
            </div>
            {/* {commonFn.interestRateDoc({
              form,
              name: "marginRate",
              label: "Margin",
              allowNegative: true,
              isNoRequired: true
            })} */}
            <Form.Item
              name="marginRate"
              label="Margin"
            >
              <Input
                placeholder="Please input Margin"
              />
            </Form.Item>
            <Form.Item
              name="rateType"
              label="Fix/Variable"
              // rules={[{ required: true, message: 'Fix/Variable is required!' }]}
            >
              <Select
                showSearch
                placeholder="Select a type"
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={[
                    {
                      label: 'Fix',
                      value: 1
                    },
                    {
                      label: 'Variable',
                      value: 2
                    },
                ]}
              />
            </Form.Item>

            {commonFn.interestRateDoc({
              form,
              name: "interestRate",
              label: "Interest Rate",
              allowNegative: true,
              isNoRequired: true
            })}

            {/* {commonFn.interestRateDoc({
              form,
              name: "ceiling",
              label: "Ceiling",
              allowNegative: true,
              isNoRequired: true
            })} */}
           <Form.Item
              name="ceiling"
              label="Ceiling"
            >
              <Input
                placeholder="Please input Ceiling"
              />
            </Form.Item>
            {/* {commonFn.interestRateDoc({
              form,
              name: "floor",
              label: "Floor",
              allowNegative: true,
              isNoRequired: true
            })} */}
            <Form.Item
              name="floor"
              label="Floor"
            >
              <Input
                placeholder="Please input Floor"
              />
            </Form.Item>
            {commonFn.formInputNumberDoc({
              form,
              name: "balloonPayment",
              label: "Balloon Payment",
              allowNegative: true,
              isNoRequired: true
            })}

            {/* {commonFn.formInputNumberDoc({
              form,
              name: "prepaidPenalty",
              label: "Prepaid Penalty",
              allowNegative: true,
              isNoRequired: true
            })} */}
           <Form.Item
              name="prepaidPenalty"
              label="Prepaid Penalty"
            >
              <Input
                placeholder="Please input Prepaid Penalty"
              />
            </Form.Item>
            <Form.Item
              name="loanType"
              label="Loan Type"
              // rules={[{ required: true, message: 'Loan Type is required!' }]}
            >
              <Select
                showSearch
                placeholder="Select a type"
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={loanTypeList}
              />
            </Form.Item>

            <Form.Item
              name="recourse"
              label="Recourse"
              // rules={[{ required: true, message: 'Recourse is required!' }]}
            >
              <Select
                showSearch
                placeholder="Select a type"
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={[
                    {
                      label: 'Yes',
                      value: 1
                    },
                    {
                      label: 'No',
                      value: 2
                    },
                ]}
              />
            </Form.Item>

            <Form.Item
              name="paidOffDate"
              label="Payoff Date"
            >
              <DatePicker
                style={{ width: "100%" }}
                format="MM/DD/YYYY"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <div
              style={{
                marginBottom: "16px",
                fontWeight: "bold",
                fontSize: "20px",
              }}
            >
              <HomeOutlined style={{ marginRight: "8px" }} />
              Upload Invoice, Photo
            </div>

            <Form.Item labelCol={{ span: 0 }} wrapperCol={{ span: 24 }} name="filePaths" label={null}>
              <CustomUploadNew1
                ref={(el) => (customUploadNewRef.current = el)}
                customConfig={{
                  pdfHeight: "76vh",
                  notMultiple: true,
                  accept: ".jpg, .jpeg, .png, .pdf",
                  status: 'add',
                  disabled: false,
                  noUploadBtn: false,
                  deleteOldFn: deleteOldFn,
                  addOldFn: addOldFn
                }}
                setFilePaths={setFilePaths} 
                filePaths={filePaths} 
                setBtnDisabled={setBtnDisabled}
                btnDisabled={btnDisabled}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <div style={{textAlign:'center'}}>
        <Space align="center">
          {/* <Button key="back" onClick={testFn}>
            TEST
          </Button> */}
          <Button key="back" onClick={() => setModalFlag(false)}>
            Cancel
          </Button>
          {
            type !== 'view' && (
              <Button type="primary" onClick={() => submitFn()} loading={btnLoading} disabled={btnDisabled}>
                Submit
              </Button>
            ) || null
          }
        </Space>
      </div>
    </Modal>
  );
});

export default MainContractModal;